<style lang="scss" src="./_scss/redeem.scss"></style>
<template>
    <section class="mod_redeem">
        <inputWrap v-if="!redeem_succ"></inputWrap>
        <!-- 成功 -->
        <div class="succ_wrap" v-if="redeem_succ">
            <img src="//puui.qpic.cn/vupload/0/20190514_1557917010779_137y6g0om0uc.png/0" alt="" class="succ_img">
            <div class="txt">{{$lang[5]}}</div>
        </div>
        <div class="btn_wrap">
            <!-- 置灰加disabled -->
            <button class="btn" @click="mainBtnClick">{{btnText}}</button>
        </div>
    </section>
</template>

<script type="text/ecmascript">
import login from '@tencent/wetv-common/login';

import { testAlert } from 'src/util/index';

import inputWrap from './input-wrap.vue';
export default {
  data() {
    return {

    };
  },
  async created() {

  },
  async mounted() {

  },
  computed: {
    redeem_succ() {
      return this.$store.state.redeem_succ;
    },
    btnText() {
      if (this.$store.state.redeem_succ) {
        return this.$lang[26];
      }
      if (this.$store.state.is_login) {
        if (this.$store.state.phone) {
          return this.$lang[4];
        }
        return this.$lang[25];
      }
      return this.$lang[24];
    },
  },
  methods: {
    async mainBtnClick() {
      if (this.$store.state.redeem_succ) {
        this.$store.commit('setState', {
          state: 'redeem_succ',
          value: false,
        });
        this.$store.commit('setState', {
          state: 'reset_flag',
          value: Math.random(),
        });
        this.$report.click({
          f_hottag: 'mod_redeembtn',
          f_module: '兑换按钮',
          f_type: 3,
          f_resource: '继续兑换',
        });
        return;
      }
      if (this.$store.state.is_login) {
        if (this.$store.state.phone) {
          // 开始兑换
          this.$store.commit('setState', {
            state: 'redeem_flag',
            value: Math.random(),
          });
          this.$report.click({
            f_hottag: 'mod_redeembtn',
            f_module: '兑换按钮',
            f_type: 3,
            f_resource: '开始兑换',
          });
        } else {
          this.toBind();
          this.$report.click({
            f_hottag: 'mod_redeembtn',
            f_module: '兑换按钮',
            f_type: 3,
            f_resource: '绑定手机',
          });
        }
      } else {
        const res = await login.openLogin();
        testAlert('actionLogin callback', res);
        if (res && !res.errCode) {
          this.$store.dispatch('getUserInfo');
        }
        this.$report.click({
          f_hottag: 'mod_redeembtn',
          f_module: '兑换按钮',
          f_type: 3,
          f_resource: '登录',
        });
      }
    },
  },
  components: {
    inputWrap,

  },
};
</script>
